import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from "axios";

import "jspdf-autotable";

// QuizTemplate için redux actions (senin mevcut dosya yolunu korudum)
import {
  getQuizTemplates as onGetQuizTemplates,
  addQuizTemplate as onAddQuizTemplate,
  updateQuizTemplate as onUpdateQuizTemplate,
  deleteQuizTemplate as onDeleteQuizTemplate,
} from "store/contacts/actions";

import { useSelector, useDispatch } from "react-redux";

const QuizTemplateList = (props) => {
  const tableRef = useRef(null);

  document.title = "QuizTemplate | Bee Education ADMIN PANELI";

  const dispatch = useDispatch();
  const [rowForDelete, setRowForDelete] = useState(null);
  const [editingRow, setEditingRow] = useState(null);
  const [isActive, setIsActive] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [categoryID, setCategoryID] = useState("");
  const [categories, setCategories] = useState([]);

  // Kategori adını güvenle çözmek için yardımcı
  const resolveCategoryTitle = (row) => {
    return (
      row?.Category?.Category_Title ||
      row?.Question_Category_Title ||
      categories.find((c) => String(c.ID) === String(row?.Question_Category_ID))
        ?.Category_Title ||
      "-"
    );
  };

  const { quizTemplates } = useSelector((state) => ({
    quizTemplates: state.contacts.quizTemplates,
  }));

  // Form
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (editingRow && editingRow.Name) || "",
      setNo: (editingRow && editingRow.Set_No) || "",
      sort: (editingRow && editingRow.Sort) || "",
      questionCategoryId:
        (editingRow && editingRow.Question_Category_ID) || categoryID || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Adı giriniz"),
      setNo: Yup.number()
        .typeError("Set No sayı olmalı")
        .required("Set No giriniz"),
      questionCategoryId: Yup.number()
        .typeError("Kategori seçiniz")
        .required("Kategori seçiniz"),
    }),
    onSubmit: (values) => {
      const payload = {
        Name: values.name,
        Category_ID: Number(values.questionCategoryId),
        Set_No: Number(values.setNo),
        IsDefault: isActive,
      };

      if (isEdit && editingRow?.ID) {
        dispatch(onUpdateQuizTemplate({ ID: editingRow.ID, ...payload }));
        setIsEdit(false);
      } else {
        dispatch(onAddQuizTemplate(payload));
      }
      validation.resetForm();
      toggle();
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Adı",
        accessor: "Name",
        filterable: true,
        Cell: (cellProps) => <NameSurname {...cellProps} />,
      },
      {
        Header: "Kategori",
        accessor: "Category.Category_Title", // gerçek alan ID; görüntüde başlığı çözeceğiz
        filterable: true,
        Cell: (cellProps) => (
          <span>{resolveCategoryTitle(cellProps.row.original)}</span>
        ),
      },
      {
        Header: "Set No",
        accessor: "Set_No",
        filterable: true,
        Cell: (cellProps) => <NameSurname {...cellProps} />,
      },
      {
        Header: "Default?",
        accessor: "IsDefault",
        filterable: true,
        Cell: (cellProps) => <Status {...cellProps} />,
      },
   
      {
        Header: "İşlemler",
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => handleEditClick(row)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => onClickDelete(row)}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    [categories]
  );

  // Kategori listesini çek
  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        "https://beeducationadmin.stechomeyazilim.info:8093/getCategoryBee/select/"
      );
      setCategories(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setCategories([]);
    }
  };

  useEffect(() => {
    fetchCategories();
    if (!quizTemplates || quizTemplates.length === 0) {
      dispatch(onGetQuizTemplates());
      setIsEdit(false);
    }
  }, [dispatch]);

  const toggle = () => setModal(!modal);

  const handleEditClick = (row) => {
    setEditingRow(row);
    setIsEdit(true);
    setIsActive(!!row.IsActive);
    setCategoryID(row.Category_ID || "");
    validation.setValues({
      name: row.Name || "",
      setNo: row.Set_No || "",
      sort: row.Sort ?? "",
      questionCategoryId: row.Category_ID || "",
    });
    toggle();
  };

  const onClickDelete = (row) => {
    setRowForDelete(row);
    setDeleteModal(true);
  };

  const handleDelete = () => {
    if (rowForDelete?.ID) {
      dispatch(onDeleteQuizTemplate(rowForDelete.ID));
    }
    setDeleteModal(false);
    setRowForDelete(null);
  };

  const handleAddClick = () => {
    setEditingRow(null);
    setIsEdit(false);
    setIsActive(false);
    setCategoryID("");
    validation.resetForm();
    toggle();
  };

  const onChangeCategory = (e) => {
    const val = e.target.value;
    setCategoryID(val);
    validation.setFieldValue("questionCategoryId", val);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="QuizTemplate Listesi" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={quizTemplates || []}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddSubCategory={true}
                    handleOrderClicks={handleAddClick}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Düzenle" : "QuizTemplate Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                                <div className="mb-3">
                              <Label className="form-label">
                                Kategori Seçiniz
                              </Label>
                              <Input
                                name="questionCategoryId"
                                type="select"
                                className="form-select"
                                value={
                                  validation.values.questionCategoryId || ""
                                }
                                onChange={onChangeCategory}
                              >
                                <option value="">
                                  Lütfen Seçim Yapınız
                                </option>
                                {categories.map((item) => (
                                  <option value={item.ID} key={item.ID}>
                                    {item.Category_Title}
                                  </option>
                                ))}
                              </Input>
                              {validation.touched.questionCategoryId &&
                              validation.errors.questionCategoryId ? (
                                <div className="invalid-feedback d-block">
                                  {validation.errors.questionCategoryId}
                                </div>
                              ) : null}
                            </div>
                            
                            <div className="mb-3">
                              <Label className="form-label">Adı</Label>
                              <Input
                                name="name"
                                type="text"
                                placeholder="QuizTemplate Adı"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.name || ""}
                                invalid={
                                  !!(
                                    validation.touched.name &&
                                    validation.errors.name
                                  )
                                }
                              />
                              {validation.touched.name &&
                              validation.errors.name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.name}
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Set No</Label>
                              <Input
                                name="setNo"
                                type="number"
                                placeholder="Set No Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.setNo || ""}
                                invalid={
                                  !!(
                                    validation.touched.setNo &&
                                    validation.errors.setNo
                                  )
                                }
                              />
                              {validation.touched.setNo &&
                              validation.errors.setNo ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.setNo}
                                </FormFeedback>
                              ) : null}
                            </div>

                       

                      

                       <div className="square-switch">

                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={isActive}
                              onChange={() =>
                                setIsActive(!isActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(QuizTemplateList);
